import { DeliveryNotificationsService } from './../../services/delivery-notifications/delivery-notifications.service';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { element } from 'protractor';
import { GeneralService } from './../../services/admin/general.service';
import { ENPOINT } from './../../services/endpoint';
import { Component, OnInit, ViewChild, TemplateRef, ViewEncapsulation, Input, NgModule } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { JSONP_ERR_WRONG_METHOD } from '@angular/common/http/src/jsonp';
import { UploadPositionComponent } from './upload-position/upload-position.component';
import { CatalogsService } from './../../services/catalogs/catalogs.service';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { StorageService } from '../../services/storage.service';
import { User } from '../../models/user';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-deliverynotifications',
  templateUrl: './delivery-notifications.component.html',
  styleUrls: ['./delivery-notifications.component.scss'],
  providers: [GeneralService, CatalogsService, DeliveryNotificationsService]
})
export class DeliveryNotificationsComponent implements OnInit {
  @Input() entradasMercanciaSeleccionadas;
  @Input() ordenesCompraSeleccionadas;
  @Input() cerrarModal;
  @ViewChild('myTable') table: any;
  @ViewChild('detailsTemplate') detailsTemplateRef: TemplateRef<any>;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  public user: User;
  private basePath;
  proveedores: CatalogsService;
  mostrarBtn = false;
  sociedades;
  ordenCompra;
  orden;
  verDetalle = false;
  ordenCompraTmp = [];
  posicion;
  em: any = [];
  entradas = [];
  rows = [];
  importeTotal = 0;
  claveMoneda = '';
  cantidad = 0;
  objEntradas = [];
  objOrdenesC = [];
  fPaginaField = 1;

  orden_compra = {
    idOrdenCompra: 0,
    condPago: '',
    idProveedor: '',
    moneda: '',
    sociedad: 0,
    flag: '',
    importeFactura: '',
    tipoDeImputacion: '',
    totalOc: '',
    indicadorWebre: '',
    centro: '',
    wo_em: '',
    dummy_rfc: '',
    dummy_nombre: ''
  };

  proveedorFilter;
  sociedadFilter;
  ordenCompraFilter;
  referenciaFilter;
  cantidadFacturas = 0;
  objLength = [];
  closeResult: string;
  modalFilters;

  busy: boolean = false;
  busyListado: boolean = false;
  busyBusqueda: boolean = false;
  busyEM: boolean = false;
  rol;

  proveedores$: Observable<any>;
  proveedoresLoading = false;
  proveedorinput$ = new Subject<string>();

  flagDatos;
  flagEntradas;
  flagBuscar;
  flagMensaje;

  toastSeleccionarEntradas;
  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });
  constructor(
    private translate: TranslateService,
    private general: GeneralService,
    private storageService: StorageService,
    public catalogs: CatalogsService,
    private deliveryNotifications: DeliveryNotificationsService,
    private modalService: NgbModal,
    private toasterService: ToasterService
  ) {
    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });

    this.translate.get('texto.toastSeleccionarEntradas').subscribe(
      text => {
        this.toastSeleccionarEntradas = text;
      });
    this.loadProyectos();
    this.basePath = ENPOINT.url;
  }

  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();
    this.rol = this.user.rol.id;
    this.modulo();
    this.getOrdenesCompra();
    this.getSociedades();
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  modulo() {
    this.general.serviceLog('Con ordenes de compra').subscribe(
      data => {
        // console.log(data);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        }
      },
    );
  }

  loadProyectos() {
    this.proveedores$ = concat(of([]),
      this.proveedorinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),

        tap(() => this.proveedoresLoading = true),
        switchMap(term =>
          this.catalogs.obtenerProveedoresBusqueda(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.proveedoresLoading = false)
          ))
      )
    );
  }

  toggleExpandRow(row) {
    this.table.rowDetail.toggleExpandRow(row);
  }

  getSociedades() {
    this.busy = true;
    this.catalogs.obtenerSociedades().subscribe(
      data => {
        this.busy = false;
        this.sociedades = data.sapSociedad;

      },
      err => {
        // console.log(err);
      },
    );
  }

  selecciones(index, row) {

    if (this.ordenCompra[this.index].posicion[index].selected) {
      this.ordenCompra[this.index].posicion[index].selected = false;

    } else {
      this.ordenCompra[this.index].posicion[index].selected = true;
    }

    this.objLength = [];
    for (let i = 0; i < this.ordenCompra.length; i++) {
      if (this.ordenCompra[i].posicion && this.ordenCompra[i].posicion.length > 0) {
        for (let j = 0; j < this.ordenCompra[i].posicion.length; j++) {
          if (this.ordenCompra[i].posicion[j].selected) {
            /* Agregar entradas de mercancia seleccionadas */
            this.objLength.push(this.ordenCompra[i].posicion[j]);
          }
        }
      }
    }
    this.cantidadFacturas = this.objLength.length;
  }

  getOrdenesCompra() {
    const rol = this.user.rol.id;
    const iPagina = this.fPaginaField;
    // Toma el Id del Usuario Proveedor
    let userProveedorId;
    if (rol === 3) {
      this.busy = true;
      userProveedorId = this.user.id;
    } else {
      if (this.proveedorFilter !== 'undefined' || this.proveedorFilter !== '') {
        userProveedorId = this.proveedorFilter;
      }
    }

    this.deliveryNotifications.obtenerOrdenesCompra(userProveedorId, iPagina).subscribe(
      data => {
        this.busy = false;

        this.ordenCompra = data.ordenCompra;
        if (this.ordenCompra.length > 0) {
          this.mostrarBtn = true;
        } else {
          this.mostrarBtn = false;
        }

        if (this.ordenCompra.length === 0) {
          this.flagDatos = true;
        } else {
          this.flagDatos = false;
        }

      },
      err => {
        // console.log(err);
      },
    );

  }

  reload() {
    this.busyListado = true;
    this.rows = [];
    this.verDetalle = false;
    this.importeTotal = 0;
    this.claveMoneda = '';
    this.ordenCompra = '';
    const rol = this.user.rol.id;
    // Toma el Id del Usuario Proveedor
    let userProveedorId;
    if (rol === 3) {
      userProveedorId = this.user.id;
    } else {
      if (this.proveedorFilter !== 'undefined' || this.proveedorFilter !== '') {
        userProveedorId = this.proveedorFilter;
      } 
    }
    this.deliveryNotifications.obtenerOrdenesCompra(userProveedorId, 1).subscribe(
      data => {
        this.ordenCompra = data.ordenCompra;
        if (this.ordenCompra.length > 0) {
          this.mostrarBtn = true;
        } else {
          this.mostrarBtn = false;
        }

        if (this.ordenCompra.length === 0) {
          this.flagDatos = true; 
        } else {
          this.flagDatos = false; 
        }

        this.busyListado = false;
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  index;
  getEntradasMercancia(orden, i) {
    this.busyEM = true;
    this.ordenCompraTmp = [];
    this.index = i;
    this.verDetalle = true;
    this.importeTotal = 0;
    this.cantidad = 0;
    this.entradas = [];
    this.orden = orden;
    const rol = this.user.rol.id;
    // Toma el Id del Usuario Proveedor
    let userProveedorId;
    if (rol === 3) {
      userProveedorId = this.user.id;
    } else {
      if (this.proveedorFilter !== 'undefined' || this.proveedorFilter !== '') {
        userProveedorId = this.proveedorFilter;
      }
    }

    this.importeTotal = this.ordenCompra[i].valor_neto;
    this.claveMoneda = this.ordenCompra[i].clave_moneda;

    if (!this.ordenCompra[i].bandera) {
      this.deliveryNotifications.obtenerPosicionOC(this.orden).subscribe(
        // tslint:disable-next-line:no-shadowed-variable
        data => {
          this.busyEM = false;
          this.posicion = data; 
          this.ordenCompra[i].posicion = this.posicion; 
          this.ordenCompra[i].bandera = true;
          for (let j = 0; j < this.ordenCompra[i].posicion.length; j++) {
            this.ordenCompra[i].posicion[j].selected = false;
          }
          this.rows = this.ordenCompra[i].posicion;

        },
        err => {
          if (err.status === 401) {
            this.storageService.openLogout();
          }
        },
      );
    } else {
      this.busyEM = false;
      this.rows = this.ordenCompra[i].posicion; 
    }
  }

  open(content) {
    this.objEntradas = [];
    this.objOrdenesC = [];

    for (let i = 0; i < this.ordenCompra.length; i++) {
      if (this.ordenCompra[i].posicion && this.ordenCompra[i].posicion.length > 0) {
        for (let j = 0; j < this.ordenCompra[i].posicion.length; j++) {
          if (this.ordenCompra[i].posicion[j].selected) {
            /* Agregar entradas de mercancia seleccionadas */
            this.objEntradas.push(this.ordenCompra[i].posicion[j]);
            /* Agregar OC seleccionadas */
            if (this.objOrdenesC.length === 0) {
              this.objOrdenesC.push(this.ordenCompra[i]);
            } else {
              for (let k = 0; k < this.objOrdenesC.length; k++) {
                if (this.objOrdenesC[k].num_doc_compras !== this.ordenCompra[i].num_doc_compras) {
                  this.objOrdenesC.push(this.ordenCompra[i]);
                  break;
                }
              }
            }

          }
        }
      }
    }

    if (this.objEntradas.length > 0 && this.objOrdenesC.length > 0) {
      const modalRef = this.modalService.open(UploadPositionComponent, { size: 'lg', keyboard: false, backdrop: 'static' });
      modalRef.componentInstance.entradasMercanciaSeleccionadas = this.objEntradas;
      modalRef.componentInstance.ordenesCompraSeleccionadas = this.objOrdenesC;
      //   modalRef.componentInstance.cerrarModal = modalRef.close();
      modalRef.result.then((result) => {
        if (result === 'cancelar') {
          // console.log('cancelo envio');
        } else {
          this.reload();
          this.objLength = [];
          this.cantidadFacturas = 0;
          this.verDetalle = false;
          this.rows = [];
          modalRef.close();
        }
      }).catch((error) => {
        // console.log(error);
      });
    } else {
      this.toasterService.pop('error', 'ERROR', this.toastSeleccionarEntradas);
    }

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getXML(orden) {

    if (orden) {
      const win = window.open(this.basePath + 'posicionOcAsn/generarXmlOC?idOrdenCompra=' + orden, '_blank');
      if (win) {
        win.focus();
      } else {
        alert('Por favor activa los popups en tu navegador');
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/delivery-notifications/delivery-notifications.component.ts